import { Box, Grid, SvgIcon, Typography } from '@mui/material'
import React from 'react'
import { Slide as SlideShow } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'

import { ReactComponent as Arrow } from '../../media/arrow_slide_icon.svg'
import quotes from '../../media/quotes.svg'

const properties = {
	duration: 5000,
	autoplay: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	transitionDuration: 500,
	arrows: true,
	infinite: true,
	easing: 'ease',
	prevArrow: (
		<SvgIcon
			component={Arrow}
			viewBox="0 0 64 64"
			sx={(theme) => ({
				cursor: 'pointer',
				transform: 'rotate(180deg)',
				[theme.breakpoints.down('md')]: {
					alignItems: 'baseline',
				},
			})}
		/>
	),
	nextArrow: <SvgIcon component={Arrow} viewBox="0 0 64 64" sx={{ cursor: 'pointer' }} />,
}

const Slide = ({ list }) => {
	return (
		<Box
			sx={(theme) => ({
				my: 4,
				[theme.breakpoints.down('md')]: {
					'& .react-slideshow-container': {
						alignItems: 'start',
						position: 'relative',

						'& svg': {
							position: 'relative',
							top: 100,
							zIndex: 100,
						},
					},
				},
			})}
		>
			<div className="slide-container">
				<SlideShow {...properties}>
					{list.map(({ url, srcset, content, artistName, agencyName, caption }, index) => (
						<div key={index} className="each-fade">
							<Grid container>
								<Grid
									item
									xs={12}
									md={5}
									sx={(theme) => ({
										'& img': {
											width: '90%',
										},
										[theme.breakpoints.down('md')]: {
											mb: 2,
										},
									})}
								>
									<img className="lazy" src={srcset} alt="" />
									<Typography
										sx={(theme) => ({
											fontWeight: 700,
											fontSize: 18,
											[theme.breakpoints.down('md')]: { mt: 2 },
										})}
									>
										{artistName}
									</Typography>
									<Typography sx={{ fontWeight: 400, fontSize: 18 }}>{agencyName}</Typography>
								</Grid>
								<Grid item xs={12} md={7}>
									<Typography
										sx={(theme) => ({
											fontWeight: 400,
											fontSize: 18,
											align: 'left',
											background: `url(${quotes}) no-repeat top left`,
											p: (theme) => theme.spacing(1, 6),
											textAlign: 'left',

											[theme.breakpoints.down('md')]: {
												p: 0,
												background: 'none',
											},
										})}
										component="p"
										dangerouslySetInnerHTML={{ __html: content }}
									/>
								</Grid>
							</Grid>
						</div>
					))}
				</SlideShow>
			</div>
		</Box>
	)
}

export default Slide
